import { request } from "../../config/API";
import authHeader from "./authHeader";

const endPoints = [
  // index 0
  {
    end: "qr",
    method: "get",
    description: "Get All QR Codes",
  },
  // index 1
  {
    end: "qr/block/", //for now adding subuser
    method: "put",
    description: "Blocks a Qr Code",
  },
  // index 2
  {
    end: "qr/my",
    method: "get",
    description: "Get Admin's QR Codes",
  },
  // index 3
  {
    end: "qr/",
    method: "delete",
    description: "Delete QR Codes",
  },
];
const getAllQr = (pageSize, currentPage) =>
  request.get(endPoints[0].end, {
    params: { pageSize, pageNumber: currentPage },
    headers: { ...authHeader() },
  });

const getAdminQrCodes = (pageSize, currentPage, id) =>
  request.get(endPoints[2].end + `/subuser/${id}`, {
    params: { pageSize, pageNumber: currentPage },
    headers: { ...authHeader() },
  });
const blockQrCode = (qrId) =>
  request.put(endPoints[1].end + qrId, null, { headers: { ...authHeader() } });

const removeQrCode = (qrId) =>
  request.delete(endPoints[3].end + qrId, { headers: { ...authHeader() } });

const qrFunctions = {
  getAllQr,
  getAdminQrCodes,
  blockQrCode,
  removeQrCode,
};

export default qrFunctions;
